import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { ACLAccessLevel, ACLAccessLevelValues, ACLUSer } from 'v2/models';
import classnames from 'classnames';
import styles from './reviewPermissionsModal.module.scss';
import _ from 'lodash';
import { ACLByEntityType } from './PermissionsForm';

const PermissionItem = ({
  acl,
  keyValue,
  onChange,
  aclByEntity,
}: {
  acl: ACLUSer;
  keyValue: string;
  onChange: (aclByEntity: ACLByEntityType) => void;
  aclByEntity: ACLByEntityType;
}) => {
  const [currentAccessLevel, setCurrentAccessLevel] = useState(
    acl.access_level
  );

  const options = Object.values(ACLAccessLevel).filter(
    (accessLevel) => accessLevel !== currentAccessLevel
  );

  useEffect(() => {
    if (currentAccessLevel !== acl.access_level) {
      const newAclByEntity = _.cloneDeep(aclByEntity);
      newAclByEntity[acl.content_type.model][acl.action].access_level =
        currentAccessLevel;
      onChange(newAclByEntity);
    }
  }, [currentAccessLevel]);

  return (
    <Dropdown className="d-inline">
      <Dropdown.Toggle
        id="dropdown-autoclose-true"
        variant="link"
        className={classnames('p-0', styles.actionBtn)}
      >
        {ACLAccessLevelValues[acl.access_level]}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options.map((accessLevel) => {
          const key = `${keyValue}_${accessLevel}_item`;
          return (
            <Dropdown.Item
              key={key}
              data-testid={key}
              onClick={() => setCurrentAccessLevel(accessLevel)}
            >
              {ACLAccessLevelValues[accessLevel]}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default PermissionItem;
